import { LogsBatch } from '@packages/shared/core/common/logger/entities';
import { GrafanaLoggerLog } from '../entities';

export function mapLogsBatchToGrafanaLoggerLogs(batch: LogsBatch): Array<GrafanaLoggerLog> {
  return batch.getLogs().map((log) => [log.getCreatedAt().toString(), log.toString()]);
}
